import { render, staticRenderFns } from "./FontTest.vue?vue&type=template&id=b14fd888&scoped=true"
import script from "./FontTest.vue?vue&type=script&lang=js"
export * from "./FontTest.vue?vue&type=script&lang=js"
import style0 from "./FontTest.vue?vue&type=style&index=0&id=b14fd888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14fd888",
  null
  
)

export default component.exports